export enum AdminAdminsTableColumnDataIndex {
  FirstName = "firstName",
  LastName = "lastName",
  Role = "role",
  Email = "email",
  Active = "active",
  Options = "options",
}
